goog.require('el8.template.multiuser_access.passwordHelpWithVerifiedEmail');
goog.require('el8.service.urls');
goog.require('el8.util.base');
goog.require('el8.uiwidget.Form');

var el8 = el8 || {};
if(!el8.multiuser_access) { el8.multiuser_access = {}; }

el8.multiuser_access.passwordHelpWithVerifiedEmail = (function() {

    var that = {};

    var faxCode = null;
    var userProfileId = null;

    function resetPasswordRequested() {



        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('passwordResetViaEmailSubmit', [faxCode, userProfileId]),
            data: JSON.stringify({}),
            async: true,
            success: function(data) {
                location.href=data.location;
            }
        });
    }

    that.init = function(spec) {
        /**
         * Initialize the global URL service
         */

        if (spec.urls) { el8.service.urls.init(spec.urls); }

        faxCode = spec.faxCode;
        userProfileId = spec.userProfileId;
        var email = spec.email;


        $('.main-content').html(
            el8.template.multiuser_access.passwordHelpWithVerifiedEmail.content({
                email: email,
                passwordHelpViewDocumentUrl: el8.service.urls.get('pagePasswordHelpViewDocument', [faxCode, userProfileId])
            })
        );

        $('.main-content').on('click', '#reset-password-link',  function(e) {
            resetPasswordRequested();
            e.preventDefault();
            return false;
        });
    };

    return that;

})();